import { toast } from "react-toastify";

import { useUpdateURLSearchParams } from "@/hooks/useQuery";
import useAddNewRole from "@/queries/profile/roles/useAddNewRole";

import { formatRoleDataForm } from "../../utils";
import RolesTabForm from "./RoleForm";
import { RoleFormModel } from "./useRoleForm";

const AddNewRoleForm = () => {
  const updateParams = useUpdateURLSearchParams();

  const { addNewRole, isLoading } = useAddNewRole();

  const onFormSubmit = (data: RoleFormModel) => {
    const formattedRolePayload = formatRoleDataForm(data);

    if (!formattedRolePayload.permissions.length) {
      toast.error("At least one permission is required");
      return;
    }
    addNewRole(formattedRolePayload)
      .then(() => {
        toast.success("Role created");
        updateParams(["addNew", undefined]);
      })
      .catch(() => {
        toast.error("Error creating role");
      });
  };

  return <RolesTabForm {...{ onFormSubmit, isPending: isLoading }} />;
};

export default AddNewRoleForm;
